import { combineReducers } from "redux"
import { availableBlocks } from "./availableBlocksReducer"

const availableBlocksReducer = combineReducers({
    availableBlocks
})

export default availableBlocksReducer

